var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/note', 'common/location'], function($, core, BaseCollection, NoteModel, location) {
  var NoteCollection;
  return NoteCollection = (function(_super) {

    __extends(NoteCollection, _super);

    function NoteCollection() {
      NoteCollection.__super__.constructor.apply(this, arguments);
    }

    NoteCollection.prototype.model = NoteModel;

    NoteCollection.prototype.initialize = function() {
      return this.personCollection = core.getCollection('persons');
    };

    NoteCollection.prototype.fetchByLedgerId = function(ledgerId) {
      var promise;
      this.path = function() {
        return core.getConfig().apiPrefix + 'internalNotes.json/ledger/' + ledgerId;
      };
      promise = this.fetch();
      return promise;
    };

    NoteCollection.prototype.saveLedgerNotes = function(ledgerId) {
      var promise;
      this.path = function() {
        return core.getConfig().apiPrefix + 'internalNotes.json/ledger/' + ledgerId;
      };
      promise = this.sync('update', this, {
        xhrFields: {
          withCredentials: true
        }
      });
      return promise;
    };

    return NoteCollection;

  })(BaseCollection);
});
